import api from "./api.js";

export default class ExcelApi {
  static async GetMemberExcel(data) {
    return await api.post(`member/excel`, data);
  }
  static async GetRetiredMemberExcel(data) {
    return await api.post(`retired-member/excel`, data);
  }
  static async GetConsultingExcel(data) {
    return await api.post(`consulting-merch/excel`, data);
  }
  static async GetConsultingReviewExcel(data) {
    return await api.post(`review/excel`, data);
  }
  static async GetPaymentExcel(data) {
    return await api.post(`payment/excel`, data);
  }
  static async LectureVideoExcel(data) {
    return await api.post(`lecture-video/excel`, data);
  }
  static async AskExcel(data) {
    return await api.post(`ask/excel`, data);
  }
}
